import { useQuery } from '@tanstack/react-query'
import { getWorkdayTimeBlockErrors } from '@lib/api'
import { workdayTimeBlockErrorKeys } from '@lib/keys'

export const useWorkdayTimeBlockErrors = (timeCardId: number) => {
  return useQuery(workdayTimeBlockErrorKeys.getByTimeCardId(timeCardId), () =>
    getWorkdayTimeBlockErrors(timeCardId),
  )
}
